var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gate-2d-page"},[_c('div',{staticClass:"main"},[_c('Gate2dData',{ref:"gateData",attrs:{"gateName":this.$router.currentRoute.name,"trackCount":_vm.audioTracksCount}}),_c('AudioPlaylistPlayer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }